import { FC, ReactNode, SyntheticEvent } from 'react';
import { Flex, FlexProps, Heading } from '@chakra-ui/react';
import { CbArrow } from '../Buttons/CbArrow';
export interface CbCarouselHeaderProps extends FlexProps {
  hasArrows?: boolean;
  heading?: string | ReactNode;
  prevDisabled: boolean;
  nextDisabled: boolean;
  onPrevClick?: (event: SyntheticEvent<HTMLButtonElement>) => void;
  onNextClick?: (event: SyntheticEvent<HTMLButtonElement>) => void;
}
export const CbCarouselHeader: FC<CbCarouselHeaderProps> = ({
  hasArrows = true,
  heading,
  prevDisabled,
  nextDisabled,
  onPrevClick,
  onNextClick,
  ...props
}) => {
  return <Flex justifyContent="space-between" {...props} data-sentry-element="Flex" data-sentry-component="CbCarouselHeader" data-sentry-source-file="CbCarouselHeader.tsx">
      {heading ? <Heading as="h2" color="luigisPants.500" fontSize="2xl">
          {heading}
        </Heading> : <Flex />}
      {hasArrows && <Flex>
          <CbArrow aria-label="Previous" direction="left" isDisabled={prevDisabled} marginRight="6px" onClick={onPrevClick} />
          <CbArrow aria-label="Next" direction="right" isDisabled={nextDisabled} onClick={onNextClick} />
        </Flex>}
    </Flex>;
};